import { motion } from "framer-motion";
import qualityIcon from "./assets/real.png";
import communicationIcon from "./assets/stream.svg";
import flexibilityIcon from "./assets/en.svg";

const iconVariants = {
  initial: { rotate: 0, scale: 1 },
  hover: { rotate: 10, scale: 1.1, transition: { duration: 0.3 } },
};

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.25, 
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 60 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
};

const EmployeeEmpowerment = () => {
  const featuress = [
    {
      id: "self-management",
      title: "Empower Employees with Self-Management",
      description:
        "Employee Self-Service allows staff to manage schedules, leave, and info, fostering ownership, accountability, and HR independence.",
      icon: qualityIcon,
      bg: "bg-[#d3f8f2]",
    },
    {
      id: "leave-management",
      title: "Streamlined Leave Management",
      description:
        "The platform centralizes leave management, automates approvals, reduces administrative workload, and eliminates errors for employees efficiently.",
      icon: communicationIcon,
      bg: "bg-[#eee8fd]",
    },
    {
      id: "efficiency-compliance",
      title: "Enhanced Efficiency and Compliance",
      description:
        "ESS enforces leave policies, ensures compliance, optimizes planning, and provides real-time data for informed decisions efficiently.",
      icon: flexibilityIcon,
      bg: "bg-[#e2fbe9]",
    },
  ];

  return (
    <div className="bg-white w-full font-epilogue px-6 md:px-10 lg:px-20 py-20 overflow-hidden">
      <div className="text-center mb-14 max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
          Employee Empowerment through Self-Service
        </h2>
        <p className="text-gray-600 text-base md:text-lg leading-relaxed">
          Empower employees to manage their own data, schedules, and tasks —
          saving time and improving transparency.
        </p>
      </div>

      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
      >
        {featuress.map((feature) => (
          <motion.div
            key={feature.id}
            className={`rounded-2xl p-8 ${feature.bg} text-center shadow-md hover:shadow-xl 
            transition-all duration-500 hover:-translate-y-2`}
            variants={cardVariants}
            whileHover={{ scale: 1.03 }}
          >
            <motion.img
              src={feature.icon}
              alt={feature.title}
              className="mx-auto w-16 h-16 mb-6"
              variants={iconVariants}
              initial="initial"
              whileHover="hover"
            />
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              {feature.title}
            </h3>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
              {feature.description}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default EmployeeEmpowerment;
